import Layout from "./Layout";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import "./assets/css/custom-primary.css";

function App() {
  return (
    <Layout />
  );
}

export default App;
